module.exports = __webpack_public_path__ + "media/medley.67e26d39.mp3";